import BookingsListPage from '../../shared/booking/BookingsListPage';

export default function PackageBookings() {
  return <BookingsListPage module="packages" title="My holiday bookings" />;
}
